
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Calais dès 290€/mois – ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Calais certifiée Google Partner, accompagne les entreprises calaisiennes pour renforcer leur visibilité en ligne et attirer davantage de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Calais dès 290€/mois – ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Calais certifiée Google Partner, accompagne les entreprises calaisiennes pour renforcer leur visibilité en ligne et attirer davantage de prospects.",
        },
      ],
    };
  },
};
